<template>
  <div class="bar-content change-pasw">
    <div class="find-content">
      <p class="title">Change password</p>
      <div class="form">
        <Nav only />
        <Input v-model="pasw" label="New password" type="password" password autocomplete="new-password">
          <div v-show="paswError" slot="bottom" class="error-box">{{ paswError }}</div>
        </Input>
        <Input v-model="cpasw" autocomplete="new-password" type="password" password label="Confirm password">
          <div v-show="cpaswError" slot="bottom" class="error-box">{{ cpaswError }}</div>
        </Input>
        <div class="btn-box">
          <Button :loading="loading" @click="changePasw">Save</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/comm/Nav';
import Input from '../../components/input/Input';
import Button from '../../components/button/Button';
import { API } from '../../net/http';
import md5 from 'js-md5';
export default {
  components: {
    Nav,
    Input,
    Button,
  },
  data() {
    return {
      pasw: '',
      cpasw: '',
      loading: false,
      paswError: '',
    };
  },
  mounted() {
    let { params } = this.$route;
    this._mail = params['mail'];
    this._code = params['code'];
    if (!this._mail || !this._code) {
      this.$router.replace('/find-password');
    }
  },
  methods: {
    changePasw() {
      this.paswError = '';
      if (this.loading) {
        return;
      }
      if (this.pasw === '') {
        this.paswError = 'required.';
        return;
      }
      if (this.pasw !== this.cpasw) {
        this.cpaswError = "passwords don't match";
        return;
      }
      this.loading = true;
      this.$post(API.authChangePassword, {
        mail: this._mail,
        code: this._code,
        pass: md5(this.pasw),
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$router.replace('/login');
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.change-pasw {
  background-color: #fff;
  padding-bottom: 40px;
  .find-content {
    width: 336px;
    margin: 0px auto;
    .title {
      .font-regular;
      margin-top: 126px;
      font-size: 18px;
      font-weight: 400;
      color: #262626;
      line-height: 24px;
      text-align: center;
    }
    .form {
      margin-top: 46px;
      .btn-box {
        width: 296px;
        margin: 26px auto 0;
      }
      .error-box {
        .font-light;
        padding-top: 10px;
        color: @app-error-color;
        font-size: 14px;
        font-weight: 300;
      }
    }
  }
}
</style>
